import api from './api'
import moment from 'moment'

function createOrUpdate(body) {
  return api.post('/admin/system-parameters', body)
}

function show() {
  return api.get('/admin/system-parameters')
}

export default {
  createOrUpdate,
  show,
}
